import { Aspect } from '@teambit/harmony';

export const MultiTesterAspect = Aspect.create({
  id: 'teambit.defender/multi-tester',
});
